import { Component, OnInit, Inject, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { IEditOptions } from '../site-edit.component';
import { ManikEntityFE } from 'src/app/manik-library/ManikEntityFE';
import { SmartButtonComponent, ISmartButton } from 'src/app/smart-button/smart-button.component';
import { IDropDownList } from 'src/app/models/web-card-model';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
import { ISmartMedia } from 'src/app/smart-media-handler/smart-media.interface';

@Component({
  selector: 'app-microsite-edit',
  templateUrl: './ecommerce.edit.component.html'
})
export class ECommerceEditComponent extends ManikEntityFE implements OnInit {
  PageForm: FormGroup;
  EffectForm: FormGroup;
  public HModel: SSEditModel = new SSEditModel();
  public HMenuModel: HMenuModel = new HMenuModel();
  @Input() public EditOption: IEditOptions;
  @ViewChild(SmartButtonComponent) SBComponent: SmartButtonComponent;
  public DesignerEffects: EEffectOptions = new EEffectOptions();
  public EffectOpenIn: IDropDownList[] = [
    { DataText: "Popup", DataValue: "P" },
    { DataText: "Overlap", DataValue: "O" },
    { DataText: "Embeded", DataValue: "E" },
  ];
  public EffectDisplayColumns: IDropDownList[] = [
    { DataText: "One Column", DataValue: "1" },
    { DataText: "Two Column", DataValue: "2" },
    { DataText: "Three Column", DataValue: "3" },
    { DataText: "Four Column", DataValue: "4" },
    { DataText: "Six Column", DataValue: "6" },
  ];

  private SectionDetls: any = {};
  public HintText: string = "";
  constructor(private formBuilder: FormBuilder,private cdRef: ChangeDetectorRef, private _manikEntityService: ManikEntityService,
    @Inject(DOCUMENT) public document: any) {
    super(document);
    this.PageForm = this.formBuilder.group({
      BusinessID: [''],
      IsActive: [''],
      MicroPageID: [''],
      PageDescription: [''],
      PageHeaderText: [''],
      PageSloganText: [''],
      ReservedIdentifier: [''],
      SectionTypeID: ['']
    });
    this.EffectForm = this.formBuilder.group({
      SelectedEffectID: [0, Validators.required],
      TargetControl: ['']
    });
  }

  ngOnInit() {
    if (this.EditOption.PortalContext) {
      sessionStorage.setItem('PortalIdentifier', this.EditOption.PortalContext);
      sessionStorage.setItem('PortalDS', this.EditOption.PortalDS);
    }
    this.HModel.BusinessID = this.EditOption.BusinessID;
    this.populateControls();
    this.getAddress();
  }

  populateControls(): void {
    let param = this.HModel.BusinessID + "_" + this.EditOption.Type; //routes[routes.length - 5];
    switch (this.EditOption.Type) {//routes[routes.length - 5]) {
      case "ECOMM":
        this.HintText = "Go Back to backend for product management";
        break;
      case "FACTSHEET":
        this.HintText = "To edit factsheet info go to business basics of backend pannel.";
        break;
      case "CONTACTUS":
        this.HintText = "To edit contact us info go to business basics of backend pannel.";
        break;
      case "MAP":
        this.HintText = "To edit map go to business basics of backend pannel.";
        break;

        
    }
    this.cdRef.detectChanges(); 
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareEditHeaders2(param, "MICROPAGE", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        this.HModel.PageData = data.ManikJSon[0].JSon0;
        this.BindPlugins(data.ManikJSon[0].JSon2[0].MicrositeSectionID);
        this.SectionDetls = data.ManikJSon[0].JSon2[0];
        this.PageForm.patchValue(this.HModel.PageData[0]);
        // this.cdRef.detectChanges(); 
        if (this.HModel.PageData[0].PageMediaHandle) {
          this.HModel.ImageDataPageMedia.MediaID = this.HModel.PageData[0].PageMediaHandle;
          this.HModel.ShowPageSmartMedia = true;
        }
        if (this.HModel.PageData[0].BGMediaHandle) {
          this.HModel.ImageDataBGMedia.MediaID = this.HModel.PageData[0].BGMediaHandle;
          this.HModel.EditBackground = true;
        }
        if (this.HModel.PageData[0].SmartButtonHandle) {
          this.HModel.SBParams.SmartButtonHandle = this.HModel.PageData[0].SmartButtonHandle;
          this.HModel.ShowPageSmartButton = true;
        }
        // this.cdRef.detectChanges(); 
        this.HModel.IsPopulated = true;
        this.HModel.IsPageLoaded = true;

      },
        error => console.log(error));
  }
  BindPlugins(MicrositeSectionID: number): void {
    this.updateFilterParams(MicrositeSectionID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("GET.PLUGIN.FOR.SECTION", "MICROSITE.DESIGNER.EFFECTS", "EOL", this.EditOption.PortalContext))
      .subscribe(data => {
        this.HModel.SectionData = data.ManikJSon[0].JSon0;
      });
  }
  getAddress(): void {
    // this.updateFilterParams(MicrositeSectionID);BUSINESS.BRANCH
// GET.LOCATIONS
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("GET.LOCATIONS", "BUSINESS.BRANCH", this.EditOption.PortalContext))
      .subscribe(data => {
      console.log('adress',data)
      });
  }

  get GetPageForm() {
    return this.PageForm.controls;
  }

  get frmEft() {
    return this.EffectForm.controls;
  }

  PopulateMenu(menu: any) {
    this.HMenuModel.IsPageSettingActive = false;
    this.HMenuModel.IsParagraphSettingActive = false;
    this.HMenuModel.IsEffectsActive = false;
    this.HMenuModel.IsBackgroundActive = false;
    this.HModel.ShowPageSettings = false;
    this.HModel.ShowSectionList = false;
    this.HModel.ShowBackgroundSettings = false;
    this.HModel.AddEffects = false;
    switch (menu) {
      case "Page":
        this.HMenuModel.IsPageSettingActive = true;
        this.HModel.ShowPageSettings = true;
        this.PageForm.patchValue(this.HModel.PageData[0]);
        break;
      case "Products":
        this.HMenuModel.IsParagraphSettingActive = true;
        this.HModel.ShowSectionList = true;
        break;
      case "Background":
        this.HMenuModel.IsBackgroundActive = true;
        this.HModel.ShowBackgroundSettings = true;
        break;
      case "Effects":
        this.HMenuModel.IsEffectsActive = true;
        this.HModel.AddEffects = true;
        setTimeout(() => {
          this.OnSelectSection(this.HModel.SectionData[0].MicrositePluginID);
        }, 20);
        break;
    }
  }

  SubmitPageSettings(event: any) {
    let body: any = {};
    body = this.PageForm.value;
    let SubmitBody = JSON.stringify({ 'items': [body] });
    console.log(body);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmitBody,
      this.prepareManageHeaders2("SMART_MANAGE", "MICROPAGE", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0;
        this.SBComponent.SubmitToDB();
        if (id != null) {
          this.showNotification('bottom', 'right', 'success', 'Page setting update: Success');
          this.populateControls();
        }
      },
        error => {
          this.showNotification('bottom', 'right', 'danger', 'Page setting update: Failure');
          this.populateControls();
        });

  }

  SubmitPageEffect(): void {
    if (this.EffectForm.invalid) {
      return;
    }

    this.FormSubmitted = true;
    let body: any = this.EffectForm.value;
    this.updateFilterParams(this.HModel.BusinessID, this.SectionDetls.MicrositeSectionID, this.ManikFilterParam3, body.SelectedEffectID, body.TargetControl);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("UPDATE.EFFECT", "MICROSITE.MENU", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0;
        this.EffectForm.clearValidators();
        this.EffectForm.reset();
        this.FormSubmitted = false;
        if (id != null) {
          this.showNotification('bottom', 'right', 'success', 'Effect update: Success');
          this.OnSelectSection(this.ManikFilterParam3);
        }
      },
        error => {
          this.showNotification('bottom', 'right', 'danger', 'Effect update: Failure');
          this.OnSelectSection(this.ManikFilterParam3);
        });
  }

  OnSelectSection(MicrositePluginID: any) {
    this.InactiveAllSubMenus();
    var submenu = document.getElementById("submenu" + MicrositePluginID);
    submenu.className += " active";
    this.updateFilterParams(this.SectionDetls.MicrositeSectionID, MicrositePluginID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("GET.EFFECTS.FOR.SECTION", "MICROSITE.DESIGNER.EFFECTS", "EOL", this.EditOption.PortalContext))
      .subscribe(data => {
        this.DesignerEffects = data.ManikJSon[0].JSon0;
        this.updateFilterParams(this.HModel.BusinessID, this.SectionDetls.MicrositeSectionID, MicrositePluginID);
        this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
          this.prepareAddlQueryHeaders2("GET.SELECTED.EFFECT", "MICROSITE.MENU", "BIZ", this.EditOption.PortalContext))
          .subscribe(data => {
            let resp: any = data.ManikJSon[0].JSon0[0];
            this.EffectForm.patchValue(resp);
            this.OnEffectSelected(resp.SelectedEffectID);
          });
      });
  }

  OnEffectSelected(EffectID: string) {
    let EffectsList: any = this.DesignerEffects;
    let selectedEffect = EffectsList.find(item => item.DataValue === EffectID);

    this.DesignerEffects.AskDynamicColCount = selectedEffect.AskDynamicColCount;
    this.DesignerEffects.IsPrimePluginFixed = selectedEffect.IsPrimePluginFixed;
    this.DesignerEffects.AskTargetControl = selectedEffect.AskTargetControl;
  }

  InactiveAllSubMenus(): void {
    for (let i = 0; i < this.HModel.SectionData.length; i++) {
      var submenu = this.document.getElementById("submenu" + this.HModel.SectionData[i].MicrositePluginID);
      submenu.classList.remove("active");
    }
  }
}

export class SSEditModel {
  public IsPageLoaded: boolean = false;
  public ShowPageSettings: boolean = true;
  public ShowSectionList: boolean = false;
  public ShowBackgroundSettings: boolean = false;
  public ImageDataPageMedia: ISmartMedia = { MediaID: "", LGContext: "BIZ", ShowItems: "NFICVYS", ShowEditOptions: true, View: 'R' };
  public ImageDataBGMedia: ISmartMedia = { MediaID: "", LGContext: "BIZ", ShowItems: "NIVYSOP", ShowEditOptions: true, View: 'E' };
  public ImageDataSectionMedia: ISmartMedia = { MediaID: "", LGContext: "BIZ", ShowItems: "NFICVYS", ShowEditOptions: true, View: 'R' };
  public SBParams: ISmartButton = { SmartButtonHandle: "", LGContext: "BIZ", PortalContext: "EMCITY" };
  public SParams: ISmartButton = { SmartButtonHandle: "", LGContext: "BIZ", PortalContext: "EMCITY" };
  public PageData: any = [];
  public SectionData: any = [];
  public MicroPageID: number;
  public BusinessID: string;
  public ShowPageSmartButton: boolean = false;
  public ShowPageSmartMedia: boolean = false;
  public IsPopulated: boolean = false;
  public EditBackground: boolean = false;
  public AddEffects: boolean = false;
}

export class HMenuModel {
  IsPageSettingActive: boolean = true;
  IsParagraphSettingActive: boolean = false;
  IsEffectsActive: boolean = false;
  IsBackgroundActive = false;
}

export class EEffectOptions {
  AskDynamicColCount: string = "N";
  AskTargetControl: string = "N";
  DataText: string;
  DataValue: number;
  IsPrimePluginFixed: string = "N";
}

